import { Button } from '@rio-cloud/rio-uikit';
import Dialog from '@rio-cloud/rio-uikit/Dialog';
import { NameInputChange } from '../../../screens/Expenses';
import { useEffect, useState } from 'react';
import InputSelect from '../Receipt/select';


interface Props {
    show: boolean;
    onClose: () => void;
    onSave: (value: string, selectCategory?: string, selectType?: string, isSubtractive?: boolean) => void;
    title: string;
    placeholder: string;
    name?: string;
    type?: string;
    expenseType?: string;
    isSubtractive?: boolean;
}

const categoryOptions = [
    { id: 'DIRETO', label: 'Despesas Diretas' },
    { id: 'OPERACIONAL', label: 'Despesas Operacionais' },
];

const typeOptions = [
    { id: 'DESPESA', label: 'Despesa' },
    { id: 'RECEITA', label: 'Receita' },
];

const signOptions = [
    { id: 'false', label: 'Positiva (+)' },
    { id: 'true', label: 'Negativa (-)' },
];

const DialogCreateCategorySetttings = ({ show, onClose, onSave, title, placeholder, name, type, expenseType, isSubtractive }: Props) => {
    const [error, setError] = useState('');
    const [errorCategorySelect, setErrorCategorySelect] = useState('');
    const [errorTypeSelect, setErrorTypeSelect] = useState('');

    const [valueCategory, setValueCategory] = useState(name || '');
    const [selectCategory, setSelectCategory] = useState('');
    const [selectType, setSelectType] = useState('');
    const [selectIsSubtractive, setSelectIsSubtractive] = useState('false');

    useEffect(() => {
        setValueCategory(name ?? "");        
        setSelectType(type ?? "");
        setSelectCategory(expenseType ?? "");
        setSelectIsSubtractive(isSubtractive ? 'true' : 'false');
    }, [name, type, expenseType, isSubtractive, show]);

    const handleSubmit = () => {
        if(!valueCategory || !selectType) {
            if (!valueCategory) {
                setError('Campo obrigatório')
            } 
            if (!selectType) {
                setErrorTypeSelect('Campo obrigatório')
            }
            return 
        }

        if(selectType === 'DESPESA' && !selectCategory) {
            setErrorCategorySelect('Campo obrigatório')
            return
        }
        
        setError('');
        setErrorTypeSelect('');
        setErrorCategorySelect('')
        
        setValueCategory('')
        setSelectCategory('')
        setSelectType('')
        setSelectIsSubtractive('false')

        onSave(valueCategory, selectCategory, selectType, selectIsSubtractive === 'true');
    }

    const handleClose = () => {
        onClose();
        setValueCategory('')
        setSelectCategory('')
        setSelectType('')
        setSelectIsSubtractive('false')

        setError('');
        setErrorTypeSelect('');
        setErrorCategorySelect('')
    }

     const inputChange = (name: NameInputChange, value?: string) => {
        setSelectCategory(value || '');
     }

     const typeCategoryChange = (name: NameInputChange, value?: string) => {
        if(value === 'RECEITA') {
            setSelectCategory('')
        }
        
        setSelectType(value || '');
     }

     const signCategoryChange = (name: NameInputChange, value?: string) => {
        setSelectIsSubtractive(value || 'false');
     }

     const contentTooltip = () => {
        return (
            <div className='display-flex flex-column align-items-start gap-5 padding-5'>
                <p className='margin-0'><span className='text-bold'>Despesas diretas:</span> Custos ligados à viagem e ao uso do veículo.</p>
                <p className='margin-0'><span className='text-bold'>Despesas operacionais:</span> Custos para manter a empresa funcionando, fora da viagem.</p>
            </div>
        )
    }

    const contentSignTooltip = () => {
        return (
            <div className='display-flex flex-column align-items-start gap-5 padding-5'>
                <p className='margin-0'><span className='text-bold'>Positiva (+):</span> Mantém o sinal padrão da transação no DRE.</p>
                <p className='margin-0'><span className='text-bold'>Negativa (-):</span> Subtrai/deduz o valor no cálculo do DRE (categoria subtrativa).</p>
            </div>
        )
    }

    return (
        <Dialog
            show={show}
            title={<span className='text-medium text-size-16'>{title}</span>}
            body={
                <>
                    <div className={`form-group ${error ? "has-feedback has-error" : ""}`}>
                        <label htmlFor="inputValue">
                            <span>{placeholder}</span>
                        </label>
                        <div className="input-group">
                            <input id="inputValue" type="text" className="form-control" value={valueCategory} onChange={(e) => setValueCategory(e.target.value)} name="value" />
                        </div>
                        {error ? (
                            <span className="form-control-feedback rioglyph rioglyph-error-sign">
                            </span>
                        ) : null}
                        <span className="help-block">
                            <span>{error}</span>
                        </span>
                    </div>
                    <div className={`form-group ${errorTypeSelect ? "has-feedback has-error" : ""}`}>
                        <InputSelect
                            inputChange={typeCategoryChange}
                            label='Qual o tipo da nova categoria?'
                            name='category'
                            onCreateNewOption={() => {}}
                            options={typeOptions}
                            value={selectType}
                            errorMessage={errorTypeSelect}
                        />
                    </div>
                    <div className="form-group">
                        <InputSelect
                            inputChange={signCategoryChange}
                            label='Qual o sinal da categoria no DRE?'
                            name='category'
                            onCreateNewOption={() => {}}
                            options={signOptions}
                            value={selectIsSubtractive}
                            tooltip={contentSignTooltip()}
                        />
                    </div>
                    {selectType === 'DESPESA' ? (
                        <div className={`form-group ${errorCategorySelect ? "has-feedback has-error" : ""}`}>
                            <InputSelect
                                inputChange={inputChange}
                                label='Qual o tipo de despesa?'
                                name='category'
                                onCreateNewOption={() => {}}
                                options={categoryOptions}
                                value={selectCategory}
                                errorMessage={errorCategorySelect}
                                tooltip={contentTooltip()}
                            />
                        </div>
                    ): null}
                </>
            }
            onClose={handleClose}
            footer={
                <div className='display-flex align-items-center justify-content-end gap-10'>
                    <Button onClick={handleClose} className='width-150 rounded-small'>Cancelar</Button>
                    <Button onClick={handleSubmit} bsStyle={Button.PRIMARY} className='width-150 rounded-small'>Salvar</Button>
                </div>
            }
            showCloseButton
        />
    )
}

export default DialogCreateCategorySetttings;